import { INonNumericReleaseItem } from '@planning/rt-stores/nnrOrder/NnrOrderItem'
import { PATHS } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'
import { useNavigate } from 'react-router'
import { ReleaseDetailsViewStore } from '../../../Stores/ReleaseDetailsViewStore'
import { ReleaseDetailsOptions } from '../../molecules/ReleaseDetailsOptions'

type Props = {
  nnrOrder: INonNumericReleaseItem
  viewStore: ReleaseDetailsViewStore
}

export const NonNumericReleaseDetailsOptions = observer(({ nnrOrder, viewStore }: Props) => {
  const navigate = useNavigate()

  const { referenceNumber, shippingLine } = nnrOrder.data

  return (
    <ReleaseDetailsOptions
      tableRef={viewStore.tableRef}
      referenceNumber={referenceNumber}
      shippingLineName={shippingLine}
      canEdit={nnrOrder.canEdit}
      onEdit={() => navigate(`${PATHS.orders.nonNumericReleases.url}/${nnrOrder.id}`)}
    />
  )
})
